<!-- <div class="denial-header">
    <span class="denial-title">Denial Letter:</span>
    <span class="denial-claim">Claim #{{claimNumber}} </span>
    <span class="denial-claim">Dennial Letter.pdf</span>
</div> -->

<div class="denial-questions">
    <upsc-collapsible-panel-light [title]="'creAutoClosureDisputes.question1.question' | translate"
        [isCollapsed]="true">
        {{'creAutoClosureDisputes.question1.answer1' | translate}}
        <ul>
            <li>Assert UPS’s liability for loss or damage.</li>
            <li>Be accompanied by proof of value or damage.</li>
            <li>Be filed in strict compliance with UPS’s claims procedures.</li>
            <li>If a valid delivery is confirmed and no damage or loss is evident, UPS does not assume liability, and
                the claim will be denied.</li>
            <li><span class="link-hover-arrow" (click)="openInNewTab('https://assets.ups.com/adobe/assets/urn:aaid:aem:c6bf8a2f-018f-4aa0-838b-ffc1a75eb1d9/original/as/terms-carriage-us-en.pdf')">Section 55 of the UPS Tariffs</span></li>
        </ul>
    </upsc-collapsible-panel-light>

    <upsc-collapsible-panel-light [title]="'creAutoClosureDisputes.question2.question' | translate"
        [isCollapsed]="true">
        <span>UPS has not been shown to be liable for the loss of your package as is referenced in section 55.1 of the
            <span class="link-hover-arrow" (click)="openInNewTab('https://assets.ups.com/adobe/assets/urn:aaid:aem:c6bf8a2f-018f-4aa0-838b-ffc1a75eb1d9/original/as/terms-carriage-us-en.pdf')">UPS Tariffs.</span>
        </span>
        <br>
        <span>In some cases, UPS might still have your package, and it is best to call UPS to see if your package was
            incorrectly marked as delivered. If you are sure that UPS lost your package, here’s some information that
            can help support your claim:
        </span>
        <ul>
            <li>Documentation from UPS stating the package was lost.</li>
            <li>Evidence that the package was lost while in possession of UPS.</li>
            <li>Documentation showing UPS did not deliver the package as intended.</li>
        </ul>

        <div class="back-icon-container">
            <div class="back" (click)="submitMoreInfo();">
                <div>Submit More Information On Your Claim</div>
                <mat-icon class="back-icon">chevron_right</mat-icon>                
            </div>            
        </div>

        <div class="more-info-form" *ngIf="submitMoreDetails">
            <upsc-more-info [claimNumber]="claimNumber" (submittedInfoMore)="submittedInfoMore($event);"></upsc-more-info>
        </div>
    </upsc-collapsible-panel-light>
</div>